import {
  createStripeSubscriptionAction,
  getPricesLoader,
} from '@app-studio-web/ui/pages/checkout/checkoutRoutes'
import { Outlet } from 'react-router-dom'
import PlansPage from './PlansPage'

// The payment step is not part of this tree: `createStripeSubscriptionAction`
// hard-redirects to /checkout/payment, so `PaymentPage` is mounted there by the
// variant-switching wrapper instead.
const v1CheckoutRoutes = [
  {
    path: 'v1',
    element: <Outlet />,
    children: [
      {
        action: createStripeSubscriptionAction,
        element: <PlansPage />,
        loader: getPricesLoader,
        path: 'plans',
      },
    ],
  },
]

export default v1CheckoutRoutes
